/** @format */

import { getSingleton, registerSingleton } from 'fe-lib-singleton'
import rawPropTypes from 'prop-types'

var PropTypes = getSingleton('prop-types')
if (PropTypes == null) PropTypes = registerSingleton('prop-types', rawPropTypes)

export const any = PropTypes.any
export const array = PropTypes.array
export const bool = PropTypes.bool
export const func = PropTypes.func
export const number = PropTypes.number
export const object = PropTypes.object
export const string = PropTypes.string
export const symbol = PropTypes.symbol
export const node = PropTypes.node
export const element = PropTypes.element

export const instanceOf = PropTypes.instanceOf
export const oneOf = PropTypes.oneOf
export const oneOfType = PropTypes.oneOfType
export const arrayOf = PropTypes.arrayOf
export const objectOf = PropTypes.objectOf
export const shape = PropTypes.shape

export default PropTypes
